import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _, { toNumber } from "lodash";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { IModal } from "../../stores";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ShowAlert } from "../../utils/functions";

interface IDeliveryDriver extends IModal {
  orderId: number;
}
const DeliveryDriver = observer(
  ({ show, setShowModal, orderId }: IDeliveryDriver) => {
    const { deliveryStore, orderStore } = useStores();
    const { drivers, fetchDrivers } = deliveryStore;
    const { assignDeliveryDriver, fetchOrders } = orderStore;
    const [driverId, setDriverId] = useState<number>(0);
    const [isFormValid, setIsFormValid] = useState(true);

    useEffect(() => {
      fetchDrivers();
    }, []);

    const driversList = useMemo(() => drivers, [drivers]);

    const validateForm = () => {
      const isValid = orderId && driverId >= 0 ? true : false;
      setIsFormValid(isValid);
    };

    useEffect(() => {
      validateForm();
    }, [driverId]);

    const submitCallback = useCallback((res: boolean) => {
      if (res) {
        setShowModal(false);
        ShowAlert.Success("Driver assigned successfully.");
        if (driverId === 0) fetchOrders();
      } else {
        ShowAlert.Error("Request failed. Please try again.");
      }
    }, []);

    const handleFormSubmit = () => {
      if (!isFormValid) {
        ShowAlert.Error("Please choose a delivery driver.");
        return;
      }

      assignDeliveryDriver(orderId, driverId, submitCallback);
    };

    return (
      <Modal show={show} onHide={() => setShowModal(false)}>
        <ModalHeader closeButton>
          <Modal.Title>
            <h5>Assign Delivery Driver</h5>
          </Modal.Title>
        </ModalHeader>
        <ModalBody>
          <form>
            <div className="form-floating mb-3">
              <select
                className="form-control"
                id="driver"
                aria-placeholder="Choose driver"
                required
                onChange={(e) => setDriverId(toNumber(e.target.value))}
              >
                <option value={0}>Unknown</option>
                {driversList.map((opt) => (
                  <option value={opt.deliveryDriverId}>{opt.name}</option>
                ))}
              </select>
              <label htmlFor="name">Choose driver</label>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-default flex-fill"
            onClick={handleFormSubmit}
            disabled={!isFormValid}
          >
            <i className="fa fa-taxi me-2"></i>
            Assing Driver
          </button>
        </ModalFooter>
      </Modal>
    );
  }
);

export default DeliveryDriver;
